import { NgModule, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterModule, RouterStateSnapshot, Routes } from '@angular/router';
import * as pages from '../../core/routing/page-names';
import { ProductAssetsComponent } from './product-assets/product-assets.component';
import { BrandLogosComponent } from './brand-logos/brand-logos.component';
import { AssetStorageComponent } from './asset-storage/asset-storage.component';
import { assetConfigurationsResolver } from './asset-configurations.service';
import { tokenRefreshResolver } from 'src/app/base/services/auth.service';
import { AssetsGuard } from 'src/app/base/guards/assets.guard';
import { AssetSettingsComponent } from './asset-settings/asset-settings.component';
import { RoleService } from 'src/app/base/services/role.service';
import { AssetCollectionsComponent } from './asset-collections/asset-collections.component';

const routes: Routes = [
  {
    path: pages.assetsPageName,
    canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AssetsGuard).canActivateAssets(state)],
    resolve: {
      configuration: assetConfigurationsResolver
    },
    children: [
      {
        path: '',
        pathMatch: 'full',
        redirectTo: pages.productAssetsPageName,
      },
      {
        path: pages.productAssetsPageName,
        component: ProductAssetsComponent,
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AssetsGuard).canActivateProductAssets(state)],
      },
      {
        path: pages.brandLogosPageName,
        component: BrandLogosComponent,
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AssetsGuard).canActivateBrandLogos(state)],
      },
      {
        path: pages.assetsStoragePageName,
        component: AssetStorageComponent,
        resolve: {
          tokenResult: tokenRefreshResolver
        },
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AssetsGuard).canActivateAssetStorage(state)],
      },
      {
        path: pages.assetCollectionsPageName,
        component: AssetCollectionsComponent,
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AssetsGuard).canActivateAssetCollections(state)],
      },
      {
        path: pages.assetsStorageSettingsPageName,
        component: AssetSettingsComponent,
        resolve: {
          tokenResult: tokenRefreshResolver,
          roleInfo: () => { return inject(RoleService).getRoleMappingInfo(); }
        },
        canActivate: [(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => inject(AssetsGuard).canActivateAssetStorageSettings(state)],
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class AssetsRoutingModule {

}
